import { chartNav } from './chartV2Nav';
import { react2angular } from 'react2angular';
import { DrilldownSuggestionContainer } from '../../../../common/ui/charts/DrilldownSuggestionContainer';

angular
    .module('signalview.chartV2', [
        'signalflowv2',
        'signalview.chartbuilder',
        'visualizationOptions',
        'signalflowV2ApiUtils.v2Chart',
        'signalview.snapshotSharing',
        'signalview.TOOLTIPS',
    ])
    .component('chartNav', chartNav)
    .component(
        'drilldownSuggestionContainer',
        react2angular(DrilldownSuggestionContainer, ['suggestions', 'onClick'])
    );
